import { METRIC_NAME } from '@/constants';
import { monitorSingleJsLoadTime } from '@/utils';
import { asyncLoadFile } from '@/utils/asyncLoadFile';
import GlobalVariables, { GLOBAL_VARIABLES } from '@/utils/global.ts';
import { smartReport } from '@/utils/metricHelper';

export function entry(data: typeof import('@/constants')['DEFAULT_ANTI_SPIDER']['main']) {
    if (window?._SHEIN_CALC_SIGNATURE_) return;
    const { url } = data
    asyncLoadFile({
        label: 'script',
        attrs: {
            // async: 'true',
            src: url,
            crossorigin: 'anonymous'
        },
    }).then(() => {
        smartReport({
            metric_name: METRIC_NAME,
            tags: { url, type: 'loadMain' },
            value: 1,
            message: 'mainjs load success',
        })
    }).then(() => {
        monitorSingleJsLoadTime('main.js', 'common.ltwebstatic.com');
    })
        .catch(error => {
            smartReport({
                metric_name: METRIC_NAME,
                tags: { url, type: 'loadMainError' },
                value: 1,
                message: 'mainjs load error',
                params: error
            })
        })
}

export async function headerOpenController(self: XMLHttpRequest, url: string) {
    if (GlobalVariables.get(GLOBAL_VARIABLES.API_PATHS).some(path => url.includes(path))) {
        let sigUrl = url
        let url2 = sigUrl.split('?')?.[0] + '?' + sigUrl.split('?')?.[1]?.replace(/'/g, '%27')
        self._customHeaders = {
            ...self._customHeaders,
            'x-gw-auth': url2
        };
    }
}

export async function headerSendController(self: XMLHttpRequest) {
    if (self?._customHeaders?.['x-gw-auth']) {
        self.setRequestHeader('x-gw-auth', await window._SHEIN_CALC_SIGNATURE_(self?._customHeaders?.['x-gw-auth']));
    }
}